(function(){
  'use strict';

  function fixDiversityLabels(){
    if (window.matchMedia && window.matchMedia('(min-width: 769px)').matches) {
      document.querySelectorAll('.diversity-banner .row.custom_margin_row').forEach(function(row){
        row.style.setProperty('display','flex','important');
        row.style.setProperty('flex-wrap','wrap','important');
        row.style.setProperty('overflow','visible','important');
      });
    }

    document.querySelectorAll('.diversity-banner .banner-common, .diversity-banner .banner-content').forEach(function(el){
      el.style.setProperty('display','block','important');
      el.style.setProperty('visibility','visible','important');
      el.style.setProperty('opacity','1','important');
      el.style.setProperty('position','static','important');
      el.style.setProperty('width','100%','important');
      el.style.setProperty('height','auto','important');
      el.style.setProperty('margin','0','important');
      el.style.setProperty('padding','0','important');
      el.style.setProperty('transform','none','important');
      el.style.setProperty('text-align','center','important');
    });

    document.querySelectorAll('.diversity-banner .ban_btn1').forEach(function(el){
      el.style.setProperty('display','block','important');
      el.style.setProperty('visibility','visible','important');
      el.style.setProperty('opacity','1','important');
      el.style.setProperty('position','static','important');
      el.style.setProperty('width','100%','important');
      el.style.setProperty('transform','none','important');
      el.style.setProperty('text-align','center','important');
      el.style.setProperty('margin','0 auto','important');
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', fixDiversityLabels);
  } else {
    fixDiversityLabels();
  }

  window.addEventListener('load', fixDiversityLabels);
})();
